{
  "name": "angular-t-rpc",
  "version": "1.3.19",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build-prod": "ng build --base-href=/portal/apps/",
    "build-prod-debug": "ng build --base-href=/portal/apps/ --configuration=production-debug",
    "build-prod-watch": "ng build --base-href=/portal/apps/ --configuration=production-watch --watch ",
    "deploy-prod": "npx tsx project-scripts/deploy-prod.ts",
    "deploy-jabdev": "npx tsx project-scripts/deploy-jabdev.ts",
    "build-development": "ng build --base-href=/portal/apps/ --configuration=development",
    "build-mpidev-debug": "ng build --base-href=/portal/apps/ --configuration=mpidev-debug",
    "deploy-mpidev": "npx tsx project-scripts/deploy-mpidev.ts",
    "deploy-mspdev": "npx tsx project-scripts/deploy-mspdev.ts",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "test:daily-summary": "npx tsx puppeteer/run-daily-summary-import.ts",
    "test:daily-summary:skip-auth": "npx tsx puppeteer/run-daily-summary-import.ts --skip-auth",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org jared-bratu --project mpi-angular-attendant ./dist && sentry-cli sourcemaps upload --org jared-bratu --project mpi-angular-attendant ./dist",
    "serve:webcomponent": "ng serve --configuration=development-webcomponent-mode",
    "build:webcomponent-dev": "ng build --base-href=/portal/ngwc-rpc/ --configuration=development-webcomponent-mode",
    "build:webcomponent-mode": "ng build --base-href=/portal/ngwc-rpc/ --configuration=webcomponent-mode",
    "build:webcomponent-prod": "ng build --base-href=/portal/ngwc-rpc/ --configuration=production-webcomponent-mode"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^17.2.4",
    "@angular/cdk": "^17.3.10",
    "@angular/common": "^17.2.4",
    "@angular/compiler": "^17.2.4",
    "@angular/core": "^17.2.4",
    "@angular/elements": "^17.2.4",
    "@angular/forms": "^17.2.4",
    "@angular/platform-browser": "^17.2.4",
    "@angular/platform-browser-dynamic": "^17.2.4",
    "@angular/router": "^17.2.4",
    "@sentry/angular": "^10.2.0",
    "@sentry/cli": "^2.51.0",
    "@trpc/client": "10.45.2",
    "@types/file-saver": "^2.0.7",
    "chart.js": "^4.4.7",
    "chartjs-adapter-date-fns": "^3.0.0",
    "date-fns": "^4.1.0",
    "file-saver": "^2.0.5",
    "moment": "^2.30.1",
    "primeflex": "^3.3.1",
    "primeicons": "^7.0.0",
    "primeng": "^17.18.15",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "xlsx": "^0.18.5",
    "zone.js": "~0.14.3"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^17.2.4",
    "@angular/cli": "^17.2.4",
    "@angular/compiler-cli": "^17.2.4",
    "@types/jasmine": "~5.1.0",
    "@types/jest": "^30.0.0",
    "@types/puppeteer": "^7.0.4",
    "cypress": "^13.7.2",
    "dotenv": "^17.2.1",
    "jasmine-core": "~5.1.0",
    "jest": "^29.7.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "mysql2": "^3.14.3",
    "puppeteer": "^24.15.0",
    "ts-jest": "^29.4.1",
    "typescript": "~5.3.2",
    "yaml": "^2.8.0"
  }
}
